export class SnapshotRecipeSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "takenFiles",
            "baseName": "takenFiles",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "takenBytes",
            "baseName": "takenBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deletedPaths",
            "baseName": "deletedPaths",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "restoredDeletions",
            "baseName": "restoredDeletions",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "flaggedWithoutCleanVersion",
            "baseName": "flaggedWithoutCleanVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sources",
            "baseName": "sources",
            "type": "Array<SnapshotRecipeSourceSummary>",
            "format": ""
        },
        {
            "name": "topDirectories",
            "baseName": "topDirectories",
            "type": "Array<SnapshotRecipeDirectorySummary>",
            "format": ""
        },
        {
            "name": "securityResultsAvailable",
            "baseName": "securityResultsAvailable",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeSummary.attributeTypeMap;
    }
    constructor() {
    }
}
